export default __webpack_public_path__ + "static/automotive-e51743948527b45b311f9ed40039f65b.jpg";